import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import s1Image from '@assets/images/hil/s1.jpeg'
import people from '@assets/images/hil/people.svg'
import CustomLink from '@shared/components/customLink'
import PropTypes from 'prop-types'
import { S3_PREFIX } from '@shared-submodule/sm-constants'

function ChampionsInfo({ info, venues }) {
  const venueCapacity = [
    { capacity: '20,111', imgUrl: 'media/attachments/1738935998198_Dubai-Stadium.jpeg' },
    { capacity: '25,021', imgUrl: 'media/attachments/1738936016255_karachi.jpeg' },
    { capacity: '30,711', imgUrl: 'media/attachments/1738936007153_Gaddafi.jpeg' },
    { capacity: '34,238', imgUrl: 'media/attachments/1738936022287_National.jpeg' }
  ]
  return (
    <>
      <div>
        <div className="d-flex justify-content-between mt-4">
          <h4 className="mt-0">Venues</h4>
          <CustomLink href="/cricket/venues" prefetch={false}>
            <a className="theme-text font-bold mt-1">{'View All'}</a>
          </CustomLink>
        </div>
        <div className={styles.venueContainer}>
          {(venues || [])?.map((venue, i) => {
            const capacity = venueCapacity[i % venueCapacity.length]?.capacity
            const imgUrl = `${S3_PREFIX}${venueCapacity[i % venueCapacity.length]?.imgUrl}`

            return (
              <div className="w-100 d-flex justify-content-between align-item-center gap-2" key={i}>
                <div className="w-75">
                  <MyImage src={imgUrl || s1Image} alt={venue?.sName} height={90} width={123} className={styles.stadiumImage} />
                </div>
                <div className="w-100">
                  <CustomLink href={venue?.oSeo?.sSlug}>
                    <div className={`${styles.stadiumTitle}`}>{venue?.sName || ''}</div>
                  </CustomLink>
                  <div className="d-flex justify-content-center gap-2 mt-2">
                    <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                      {/* <MyImage src={location} className={styles.loImg} /> */}
                      <p className="mb-0">{venue?.sLocation || ''}</p>
                    </div>
                    <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                      <MyImage src={people} className={styles.loImg} alt={venue?.sName} />
                      <p className="mb-0">{capacity}</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

ChampionsInfo.propTypes = {
  info: PropTypes.array,
  venues: PropTypes.array
}

export default ChampionsInfo
